/** @jsxRuntime automatic */
/** @jsxImportSource react */
import React, { createContext, useContext } from "react"
import { TbDatabaseOff } from "react-icons/tb"

// Per widget (WidgetFrame): `connect` opens that widget's inspector on Data; null in Preview and the PDF.
export const WidgetEmptyContext = createContext({ connect: null })

// A widget with nothing to show (Batch 3). In the editor: a small grey icon, the reason in one line, and a
// quiet "Connect data" that opens the widget's Data settings. In Preview and the PDF: only a muted "—" (KPI)
// or "No data", so a sent page never carries editing copy.
// `message` / `action` (backlog #19): a specific reason, such as a pie with negative values or a filter with no column,
// says what is wrong and offers its own button in the editor (it opens the same settings). `quiet`: nothing at all in
// Preview and the PDF (an unset filter is not shown to a reader).
export function WidgetEmpty({ labels, reason, kpi, message, action, quiet }) {
  const context = useContext(WidgetEmptyContext)
  const l = labels?.designer || {}
  if (message && !context.connect && quiet) return null
  if (message && context.connect)
    return (
      <div className="datox-react-dashboard__widget-empty datox-react-dashboard__widget-empty--action" role="status" data-empty={reason}>
        <span className="datox-react-dashboard__widget-empty-text">{message}</span>
        {action ? (
          <button
            type="button"
            className="datox-react-dashboard__widget-empty-button"
            onClick={(event) => {
              event.stopPropagation()
              context.connect()
            }}
          >
            {action}
          </button>
        ) : null}
      </div>
    )
  // Bound to data that has no values for this client this month (UX research E15): the banker can't connect anything,
  // so it says so, without a button.
  if (context.connect && reason === "noValues")
    return (
      <div className="datox-react-dashboard__widget-empty" role="status" data-empty={reason} data-kpi-state={kpi ? "missing" : undefined}>
        <span className="datox-react-dashboard__widget-empty-text">{l.emptyNotInData || l.emptyNoValues || labels?.noValues}</span>
      </div>
    )
  if (!context.connect)
    return (
      <div className="datox-react-dashboard__widget-empty" role="status" data-empty={reason} data-kpi-state={kpi ? "missing" : undefined}>
        {kpi ? "—" : labels?.noData || labels?.kpi?.missing || "—"}
      </div>
    )
  return (
    <div className="datox-react-dashboard__widget-empty datox-react-dashboard__widget-empty--action" role="status" data-empty={reason} data-kpi-state={kpi ? "missing" : undefined}>
      <TbDatabaseOff className="datox-react-dashboard__widget-empty-icon" aria-hidden="true" />
      <span className="datox-react-dashboard__widget-empty-text">
        {reason === "noValues" ? l.emptyNoValues || labels?.noValues : l.emptyNotConnected || labels?.notConnected}
      </span>
      <button
        type="button"
        className="datox-react-dashboard__widget-empty-button"
        onClick={(event) => {
          event.stopPropagation()
          context.connect()
        }}
      >
        {l.connectData}
      </button>
    </div>
  )
}
